import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { useStateValue } from '@State'
import { MultiSelect, WizardSteps } from '../../components'
import { linkPaths } from '../urls'

export function Requirements() {
  const [state, dispatch] = useStateValue()
  const history = useHistory()

  const goBack = e => {
    e.preventDefault()
    history.push(linkPaths.design)
  }

  const goNext = e => {
    e.preventDefault()
    history.push(linkPaths.review)
  }

  const generateSelectField = () => {
    let scoreOptions = []
    for (var i = 1; i < 21; i++) {
      scoreOptions.push(
        <option value={i * 5} key={i * 5}>
          {i * 5}%
        </option>
      )
    }
    return (
      <select
        id="passing-score"
        onChange={handleSelectChange}
        value={state.badgeInfo.passingScore}
        className="form-control"
      >
        {scoreOptions}
      </select>
    )
  }

  const handleSelectChange = event => {
    dispatch({ type: 'PUSH_PASSING_SCORE', passingScore: event.target.value })
  }

  const handleAssessmentsChange = event => {
    if (event.target.checked) {
      dispatch({
        type: 'PUSH_ASSESSMENTS',
        selectedAssessments: [...state.badgeInfo.selectedAssessments, event.target.value],
      })
    } else {
      let selected = [...state.badgeInfo.selectedAssessments]
      selected.splice(selected.indexOf(event.target.value), 1)
      dispatch({ type: 'PUSH_ASSESSMENTS', selectedAssessments: selected })
    }
  }

  const handleChaptersChange = event => {
    if (event.target.checked) {
      dispatch({
        type: 'PUSH_CHAPTERS',
        selectedChapters: [...state.badgeInfo.selectedChapters, event.target.value],
      })
    } else {
      let selected = [...state.badgeInfo.selectedChapters]
      selected.splice(selected.indexOf(event.target.value), 1)
      dispatch({ type: 'PUSH_CHAPTERS', selectedChapters: selected })
    }
  }

  const handleVideosChange = event => {
    if (event.target.checked) {
      dispatch({
        type: 'PUSH_VIDEOS',
        selectedVideos: [...state.badgeInfo.selectedVideos, event.target.value],
      })
    } else {
      let selected = [...state.badgeInfo.selectedVideos]
      selected.splice(selected.indexOf(event.target.value), 1)
      dispatch({ type: 'PUSH_VIDEOS', selectedVideos: selected })
    }
  }

  const needsRequirements =
    state.badgeInfo.selectedAssessments.length === 0 &&
    state.badgeInfo.selectedChapters.length === 0 &&
    state.badgeInfo.selectedVideos.length === 0

  return (
    <div>
      <WizardSteps
        edit={state.badgeInfo.retrievedEditData}
        step={2}
        linkPaths={linkPaths}
        heading="Badge"
        subHeading="Define Requirements"
      />
      <div className="requirements-container">
        <form>
          <MultiSelect
            label="Required Assessments: "
            onSelected={handleAssessmentsChange}
            contentArray={Object.keys(state.assessments).map(pk => ({
              name: state.assessments[pk],
              checked: state.badgeInfo.selectedAssessments.includes(pk) === true,
              id: pk,
            }))}
          />
          <div className="form-row">
            <div className="form-label">
              <label className="fs-xl" htmlFor="passing-score">
                Lowest Passing Score:
              </label>
            </div>
            <div className="field">{generateSelectField()}</div>
          </div>
          <MultiSelect
            label="Required Reading: "
            onSelected={handleChaptersChange}
            contentArray={state.chapters.chapterChoices.map(obj => ({
              name: obj.title,
              checked: state.badgeInfo.selectedChapters.includes(obj.id) === true,
              id: obj.id,
            }))}
          />
          <br />
          {state.videos.videoChoices.length > 0 ? (
            <MultiSelect
              label="Required Videos: "
              onSelected={handleVideosChange}
              id="videos"
              contentArray={state.videos.videoChoices.map(obj => ({
                name: obj.title,
                checked: state.badgeInfo.selectedVideos.includes(obj.id) === true,
                id: obj.id,
              }))}
            />
          ) : (
            <div />
          )}
        </form>
        <div className="btn_container">
          <Button variant="primary" onClick={goBack}>
            Back
          </Button>
          <Button
            variant="primary"
            disabled={needsRequirements}
            onClick={goNext}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}
